export function PublicPageLoadTiming(
    $rootScope,
    PublicPageLogApi, 
    $window, 
    BdStorage
) {
    const storageKey = 'Performance.PublicAngularPageLoadStart';

    function getStartFromPage() {
        return $window.PublicAngularPageLoadStart;
    }

    function getStartFromStorage() {
        const storedValue = BdStorage.localstorage.get(storageKey);
        return parseFloat(storedValue);
    }

    function getStart(fromState) {
        if (fromState.name) {
            return getStartFromStorage() || getStartFromPage();
        }

        return getStartFromPage() || getStartFromStorage();
    }

    function storeStartInStorage() {
        const startTime = $window.performance.now();
        BdStorage.localstorage.set(storageKey, startTime);
    }

    $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState) {
        if (!toState.data || !toState.data.timePageLoad) {
            return;
        }

        if ($window.IsPublicPagesPerformanceLogServiceAvailable) {
            const pageLoadStart = getStart(fromState);
            const loadTime = $window.performance.now() - pageLoadStart;
            if (loadTime > 0) {
                PublicPageLogApi.logPagePerformance({
                    Url: $window.location.pathname,
                    LoadTimeInMilliseconds: Math.round(loadTime)
                });
            }
        }
    });

    $rootScope.$on('$stateChangeStart', function(event, toState) {
        if (!toState.data || !toState.data.timePageLoad) {
            return;
        }

        storeStartInStorage();
    });
}

PublicPageLoadTiming.$inject = [
    '$rootScope',
    'PublicPageLogApi',
    '$window',
    'BdStorage'
];
